import { JSX } from 'react'

import { IconProps } from '../../icon'

const Back: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M39.7692 22.919H13.201L16.0236 20.0964C16.4995 19.6205 16.4995 18.8328 16.0236 18.3569C15.5477 17.881 14.76 17.881 14.2841 18.3569L9.36103 23.28C9.24615 23.3949 9.1641 23.5262 9.09846 23.6738C8.96718 23.9692 8.96718 24.3138 9.09846 24.6092C9.1641 24.7569 9.24615 24.8882 9.36103 25.0031L14.2841 29.9262C14.5303 30.1723 14.8421 30.2872 15.1538 30.2872C15.4656 30.2872 15.7774 30.1723 16.0236 29.9262C16.4995 29.4503 16.4995 28.6626 16.0236 28.1867L13.201 25.3641H39.7692C40.4421 25.3641 41 24.8062 41 24.1333C41 23.4605 40.4421 22.9026 39.7692 22.9026V22.919Z'
      fill='black'
    />
  </svg>
)

export default Back
